
function Beaches() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/coast-img/sandburg.jpg" alt="Sandburg" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Wismars Strände</h1>
                            <p>Es gibt nicht nur einen? Richtig, Wismar kann gleich mit mehreren Stränden aufwarten. 
                                Über die wichtigsten und am besten erreichbarsten kannst du dir hier einen 
                                Überblick verschaffen.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Poel Am Schwarzen Busch</h2>
                            <p>Nordöstlich von Wismar gelegen befindet sich die Halbinsel Poel. Diese lässt sich per 
                                Fähre, Auto oder auch mit dem Fahrrad gut erreichen. Der Strand Am Schwarzen Busch liegt 
                                im Norden der Halbinsel und gehört zu den Klassikern der Wismarer Strände.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Poel Timmendorf</h2>
                            <p>Auch Wismar hat einen Timmendorfer Strand. Nicht zu verwechseln mit jenem in Schleswig-Holstein. 
                                Der Timmendorfer Strand auf Poel liegt im westlichen Teil der Halbinsel. Kleingeld nicht vergessen, 
                                an den Stränden ist jeweils für die Aufenthaltsdauer eine geringe Strandgebühr bzw. Kurtaxe zu 
                                entrichten.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wendorf</h2>
                            <p>Der Wendorfer Strand ist der nächst gelegene und vom Apartment 5 aus am schnellsten zu erreichen. 
                                Er befindet sich an der westlichen Küstenlinie. Die zugehörige Seebrücke Bad Wendorf ist ideal 
                                für kleine Spaziergänge, zum Beispiel nach einem ausgiebigen Lunch im Hotel Seeblick nebenan.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Zierow</h2>
                            <p>Weiter entlang der westlichen Küste befindet sich der Badestrand Zierow. Hier gibt es Natur pur, 
                                der Strand ist eher klein, dafür aber weniger bekannt und weniger überfüllt. Für Snacks & Co. sucht 
                                man am besten das Örtchen Zierow auf.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Hohen Wieschendorf</h2>
                            <p>Ein paar Meter weiter erreicht man Hohen Wieschendorf, ein kleines Strandparadies mit Bootsanleger 
                                und damit auch per Boot erreichbar. Für ein gediegenes Lunch oder leckeres Dinner bietet sich das 
                                Restaurant Little Italy an. Wer auch gleich den Golfschläger schwingen möchte, kommt im 
                                Bades Huk Golfclub auf seine Kosten.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Beckerwitz</h2>
                            <p>Einmal um die Landzunge herum befindet sich das kleine Örtchen Beckerwitz nebst weiläufigem Strand. 
                                Ein Strand wie aus dem Bilderbuch, mit hellem Sand, kleinen Klippen und hohen Bäumen. Beckerwitz ist 
                                vom Apartment 5 am besten mit dem Auto erreichbar, ein Bus verkehrt hier ebenfalls.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wohlenberger Wiek</h2>
                            <p>Von Beckerwitz aus zieht sich der hellsandige Strand weiter bis zur Wohlenberger Wiek. Bestens 
                                geeignet für einen einstündigen Spaziergang entlang der Ostseewellen. Gleich mehrere Parkplätze 
                                in regelmäßigen Abständen erlauben aber auch die Anreise per Auto. Auch hier unbedingt Kleingeld 
                                mitbringen für die Strandgebühr.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default Beaches;